<template>
    <v-layout row wrap>
        <loading-component :value="loading"/>
        <v-flex xs4>
            <bar-chart :x-labels='ratings'
                       :datasets="ratingsStats"
            />
        </v-flex>
        <v-flex xs4>
            <bar-chart :x-labels='ratingCauses'
                       :datasets="ratingCausesStats"
            />
        </v-flex>
        <v-flex xs4>
            <v-flex xs12 class="pa-3">
                <v-select :items="[1,2,3,4,5]" v-model="rating_values" label="Rating Values" multiple/>
            </v-flex>
            <v-flex xs12 class="pa-3">
                <choose-date v-model="start" label="Start"/>
            </v-flex>
            <v-flex xs12 class="pa-3">
                <choose-date v-model="end" label="End"/>
            </v-flex>
        </v-flex>

        <v-flex xs12 class="px-2">
            <data-table :url="api.ACTIONS.CAPTAIN_RATINGS(captain_id)"
                        :initial-url-search-params="params"
                        disable-search
                        :enable-delete="false"
                        :enable-add="false"
                        :fields-hidden-main="['first_name','last_name']"
                        :enable-edit="false"
                        :formatter="formatter"
                        :fields-extra-main="fieldsExtraMain"
                        sort-by="datetime"
                        descending
            />
        </v-flex>
    </v-layout>
</template>

<script>
    import moment from "moment";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import DataTable from "@/components/wasilni/DataTable";
    import LoadingComponent from "@/components/LoadingComponent";
    import BarChart from "@/components/widgets/statistic/BarChart";

    export default {
        name: "rating-log",
        components: {LoadingComponent, BarChart, DataTable, ChooseDate},
        props: {
            'captain_id': {
                required: true,
                type: Number
            }
        },
        data() {
            return {
                loading: false,
                start: moment().startOf('week').format("YYYY-MM-DD"),
                end: moment().endOf('week').format("YYYY-MM-DD"),
                rating_values: [1, 2, 3, 4, 5],
                stats: {
                    ratingCauses: [
                        {cause: "Cause", count: 0}
                    ],
                    ratings: [
                        {passenger_rating: null, count: 0}
                    ]
                }
            }
        },
        methods: {
            async getStats() {
                this.loading = true;
                const {data: {data}} = await this.axios.get(this.api.ACTIONS.CAPTAIN_RATING_STATS(this.captain_id), {params: this.startEndParams});
                this.stats = data;
                this.loading = false;
            }
        },
        mounted() {
            this.getStats();
        },
        watch: {
            startEndParams() {
                this.getStats();
            }
        },
        computed: {
            fieldsExtraMain() {
                return {
                    passenger_name(item) {
                        return item.first_name + " " + item.last_name;
                    }
                }
            },
            ratings() {
                return ["N\\A", "1", "2", "3", "4", "5"];
            },
            ratingsStats() {
                return [
                    {
                        label: "Count of ratings",
                        data: this.ratings.map(rating => {
                            const ratingInt = rating === "N\\A" ? null : parseInt(rating);
                            const matchingVal = this.stats.ratings.filter(i => i.passenger_rating === ratingInt)[0];
                            if (!matchingVal)
                                return 0;
                            else
                                return matchingVal.count;
                        }),
                        fill: false,
                        backgroundColor: "#4444F7",
                        borderColor: "#FFF",
                        borderWidth: 1
                    }
                ];
            },
            ratingCauses() {
                return this.stats.ratingCauses.map(rating => rating.cause);
            },
            ratingCausesStats() {
                return [
                    {
                        label: "Count of causes",
                        data: this.stats.ratingCauses.map(rating => rating.count),
                        fill: false,
                        backgroundColor: "#4444F7",
                        borderColor: "#FFF",
                        borderWidth: 1
                    }
                ];
            },
            params() {
                const params = new URLSearchParams();
                params.append('start', this.start);
                params.append('end', this.end);
                this.rating_values.forEach(rating_value => params.append('rating_values[]', rating_value));
                return params;
            },
            startEndParams() {
                const params = new URLSearchParams();
                params.append('start', this.start);
                params.append('end', this.end);
                return params;
            },
            formatter() {
                return {
                    passenger_causes(val) {
                        if (!val || val.length === 0)
                            return "No Causes";

                        return val.map(cause => cause.cause).join(",")
                    },
                    passenger_rating_cause(val) {
                        if (!val)
                            return "No Cause";
                        else return val;
                    }
                }
            }
        }

    }
</script>

<style scoped>

</style>